import Util from "@/components/js/util.js"

const text = wps.Application.ActiveDocument.Range().Text;
const CWps = wps;

function openDialog (url, title, width, height, modal = true) {
  width = width || 200;
  height = height || 200;
  wps.ShowDialog(
    Util.GetUrlPath() + url,
    title,
    width * window.devicePixelRatio,
    height * window.devicePixelRatio,
    modal
  );
}

function deWeight (array, name) {
  let deWeightThree = () => {
    let map = new Map();
    for (let item of array) {
        if (!map.has(item[name])) {
            map.set(item[name], item);
        }
    }
    return [...map.values()];
}
return deWeightThree();
}

// function show() {

// }

export default {
  text,
  CWps,
  openDialog,
  deWeight,
}
